import styled from 'styled-components';

export default styled.div`
  position: fixed;
  z-index: 1;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;
